/**
 * Truncate the decimal portion of a numeric string to at most `maxDecimals`
 * digits. Preserves the user's raw typing (intermediate states like "1." or
 * "" pass through unchanged) so it can be wired directly into a TextField
 * onChange. Non-numeric input is returned as-is.
 */
export function clampDecimalPlaces(value: string, maxDecimals: number = 12): string {
  if (typeof value !== 'string' || value === '') return value
  const match = value.match(/^([+-]?\d*)(\.(\d*))?$/)
  if (!match) return value
  const intPart = match[1] || ''
  const decPart = match[3]
  if (decPart === undefined) return value
  if (decPart.length <= maxDecimals) return value
  const trimmed = decPart.slice(0, maxDecimals)
  return trimmed.length > 0 ? `${intPart}.${trimmed}` : intPart
}
